import { BreakpointMinSizes } from "@/services/breakpoint.service";
import { LayoutSettings } from "@/utils/swiper";

export const layoutSettings: LayoutSettings = {
    [BreakpointMinSizes.xs]: {
        slidesPerView: 3.6,
        slidesPerGroup: 3,
        direction: "horizontal"
    },
    [BreakpointMinSizes.sm]: {
        slidesPerView: 3.6,
        slidesPerGroup: 3,
        direction: "horizontal"
    },
    [BreakpointMinSizes.md]: {
        slidesPerView: 3.6,
        slidesPerGroup: 3,
        direction: "horizontal"
    },
    [BreakpointMinSizes.lg]: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        direction: "horizontal"
    },
    [BreakpointMinSizes.xl]: {
        slidesPerView: "auto",
        direction: "vertical"
    }
};
